'use strict';

var Close = require('../../../_virtual/Close.js_commonjs-exports.js');
var interopRequireDefault = require('../../@babel/runtime/helpers/interopRequireDefault.js');
var React = require('react');
require('./utils/createSvgIcon.js');
var createSvgIcon = require('../../../_virtual/createSvgIcon.js_commonjs-exports.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _interopRequireDefault = interopRequireDefault;

Object.defineProperty(Close.__exports, "__esModule", {
  value: true
});
exports["default"] = Close.__exports.default = void 0;

var _react = _interopRequireDefault(React__default["default"]);

var _createSvgIcon = _interopRequireDefault(createSvgIcon.__exports);

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');

exports["default"] = Close.__exports.default = _default;

module.exports = exports["default"];
